import React from 'react'
import styled from 'styled-components'
import { brand } from 'sutra/tokens/colors'

export interface EyebrowProps {
  children?: React.ReactNode
  className?: string
  style?: React.CSSProperties
}

const StyledEyebrow = styled.p`
  font-family: 'Poppins', system-ui, sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: ${brand.stillNight[500]};
  margin: 0;
  letter-spacing: 0;
`

export const Eyebrow = ({
  children,
  className,
  style,
}: EyebrowProps): React.ReactElement => (
  <StyledEyebrow className={className} style={style}>
    {children}
  </StyledEyebrow>
)

Eyebrow.displayName = 'Eyebrow'
